// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"175":"1420cc45","233":"0edb777a","369":"c66d0dff","936":"f2c8a5e0"}[chunkId] + ".css";
};